module.exports = __webpack_public_path__ + "static/media/c2_5.7ab7489c.png";